import { useEffect } from 'react';

const APP_STORE = 'https://apps.apple.com/br/app/kinology/id1275941432';
const PLAY_STORE = 'https://play.google.com/store/apps/details?id=com.esportese.elastic';
const WEB_FALLBACK = 'https://areacliente.kinology.com.br';
const DEEPLINK = 'kinology://AreaCliente';
const TIMEOUT = 10000;

function detectPlatform() {
    const ua = navigator.userAgent;
    if (/iphone|ipad|ipod|apple/i.test(ua)) return 'ios';
    if (/android|google/i.test(ua)) return 'android';
    return 'other';
}

export default function DeepLink() {
    useEffect(() => {
        const platform = detectPlatform();

        if (platform === 'android') {
            const intent = `intent://AreaCliente#Intent;scheme=kinology;package=com.esportese.elastic;S.browser_fallback_url=${encodeURIComponent(PLAY_STORE)};end`;
            window.location.href = intent;
            return;
        }

        if (platform === 'ios') {
            window.location.href = DEEPLINK;

            const timer = setTimeout(() => {
                if (!document.hidden) window.location.href = APP_STORE;
            }, TIMEOUT);

            const onHide = () => clearTimeout(timer);
            document.addEventListener('visibilitychange', onHide, { once: true });

            return () => {
                clearTimeout(timer);
                document.removeEventListener('visibilitychange', onHide);
            };
        }

        window.location.href = WEB_FALLBACK;
    }, []);

    return (
        <div className='w-full h-full flex'>

        </div>
    )
}